<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img src="https://onedio.com/images/logo/onedio-new2x-new.png" width="89" height="25" alt="Onedio-Dashboard">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">   

        
        <DefaultHeaderDropdownAccnt/>


      </b-navbar-nav>
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
     <!--  <div class="alert alert-warning" role="alert" v-if="warning">
  Please select exactly two dates.
    Try again.
</div> -->
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        
        <SidebarNav :navItems="nav" >
         </SidebarNav>
         
          <!-- <b-button  variant="dark" @click="dashboard_revenue">
            <i class="fa fa-check fa-lg mt-4"></i>
            Revenue
         </b-button>
          <b-form-select id="traffic" class="card-title mb-0 form-help" v-if="selectedData === 'revenues'" v-model="selectedCurrency" :plain="true" :options="currencyOptions">
          </b-form-select>
         <b-button   variant="dark" @click="dashboard_impression">
           <i class="fa fa-check fa-lg mt-4"></i>
           Impression
         </b-button>
         <b-button   variant="dark" @click="dashboard_ecpm"  >
           <i class="fa fa-check fa-lg mt-4"></i>
           Ecpm
         </b-button>
         <b-button   variant="dark" @click="dashboard_adrequest" >
           <i class="fa fa-check fa-lg mt-4"></i>
           Ad Request
         </b-button>
         <b-button   variant="dark" @click="dashboard_ctr">
           <i class="fa fa-check fa-lg mt-4"></i>
           Ctr  
         </b-button> -->
         
        <SidebarFooter/>
        <SidebarMinimizer class="mt-auto">
        </SidebarMinimizer>
      </AppSidebar>
      <main class="main">
        <div>
         <b-row>
            <b-col sm="5"> 
        <Breadcrumb :list="list">
        </Breadcrumb>
            </b-col>
           <b-col sm="3"> 
             <div class="datepicker-trigger">
              <b-input-group >
                <b-input-group-prepend>
                  <span class="input-group-text"><i class="icon-calendar"></i></span>
                </b-input-group-prepend>
                <b-form-input 
                  type="text"
                  id="datepicker-trigger"
                  placeholder="Select dates"
                  :value="formatDates(dateOne, dateTwo)"
                  autocomplete="off"
                >
                </b-form-input>
              </b-input-group>
              <AirbnbStyleDatepicker
                :trigger-element-id="'datepicker-trigger'"
                :min-date="'2018/8/7'"
                :endDate=getEndDate()
                :mode="'range'"
                :fullscreen-mobile="true"
                :showMonthYearSelect="true"
                :date-one="dateOne"
                :date-two="dateTwo"
                @date-one-selected="val => { dateOne = val }"
                @date-two-selected="val => { dateTwo = val }"
                @apply="confirm"
              />
            </div>
          </b-col>
           <b-col sm="4">
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-button-group>
                <b-button v-bind:class="threeObject" @click="changeDateVisible('3Visible')">3 Days</b-button>
                <b-button v-bind:class="sevenObject" @click="changeDateVisible('7Visible')">7 Days</b-button>
                <b-button v-bind:class="fourTeenObject" @click="changeDateVisible('14Visible')">14 Days</b-button>
                <b-button v-bind:class="thirtyObject" @click="changeDateVisible('30Visible')">30 Days</b-button>
                <b-button v-bind:class="oneEightyObject" @click="changeDateVisible('180Visible')">180 Days</b-button>
              </b-button-group>
              </b-button-toolbar> 
           </b-col>
        </b-row>
        </div>
        <div class="container-fluid">
          <router-view  :key="$route.fullPath" :setData="setData"></router-view>
        </div>
        
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://onedio.com">Onedio</a>
        <span class="ml-1">&copy; 2019 Onedio</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by Onedio Developers</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import format from 'date-fns/format'
export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data () {
    return {
      threeObject: {
          active: false,
          'btn btn-light': true
        },
        sevenObject: {
          active: true,
          'btn btn-light': true
        },
        fourTeenObject: {
          active: false,
          'btn btn-light': true
        },
        thirtyObject: {
          active: false,
          'btn btn-light': true
        },
        oneEightyObject: {
          active: false,
          'btn btn-light': true
        },
      nav: nav.items,
      selectedData:'',
      currencyOptions:[{text:'₺ (TL)',value:'TRY'},
                {text:'$ (USD)',value:'USD'},
                {text:'₽ (RUB)',value:'RUB'}],
      selectedCurrency:'TRY',
      minimized:false,
      dateOne:'',
      dateTwo:'',
      newdateFormat:'YYYY-MM-DD',
      warning:false,
      setData:0,
      mutationOption:'',
      request:false,
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    key() {
      return this.$route.name !== undefined ? this.$route.name : this.$route
    }
    
  },
  methods:{
    dashboard_revenue(){
      this.selectedData='revenues'
    },
    dashboard_impression(){
      this.selectedData='impressions'
    },
    dashboard_ecpm(){
      this.selectedData='ecpms'
    },
    dashboard_adrequest(){
      this.selectedData='ad_requests'
    },
    dashboard_ctr(){
      this.selectedData='ctrs'
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.newdateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.newdateFormat)
      }
      return formattedDates
    },
    getEndDate() {
        let date = new Date();
        date.setDate(date.getDate() - 1)
        return this.endDate = date.toString();
      },
      async confirm(date) {
        //pick date function
        let date1 = this.dateOne
        let date2 = this.dateTwo
        let mutationOption
        if(!date2 || !date1){
          alert("Please select exactly two dates.\nTry again.")
          date1=''
          this.dateOne=''
          date2=''
          this.dateTwo=''
          return
        } 
        await this.$store.dispatch('SET_MAIN_ITEMS_SEARCH', {date1,date2});
        await this.$store.dispatch('MAIN_OVERVIEWS_SEARCH_DATA', {date1,date2})
        await this.$store.dispatch('SET_TRAFFIC_DATA_SEARCH', {date1,date2});
        this.threeObject.active = false;
        this.sevenObject.active = false;
        this.fourTeenObject.active = false;
        this.thirtyObject.active = false;
        this.oneEightyObject.active = false;
        let inactive=false
        await this.$events.fire('SET_DATES',this.$store.state.mainOverviewsData.filterDates)
      await this.$events.fire('SET_DATES_MAIN',this.$store.state.itemsData.filterDates)
       await this.$events.fire('SET_DATES_TRAFFIC',this.$store.state.trafficData.filterDates)
        await this.$store.dispatch('SET_BUTTON_ACTIVES',{a: inactive, b: inactive, c: inactive,d:inactive,e:inactive})
        await this.$store.dispatch('SET_SEARCH_DATES',{date1,date2})
        await this.setData++

      },
      async changeDateVisible(visible){
        //days button visible
         this.dateOne=''
         this.dateTwo=''
         let date1=this.dateOne
         let date2=this.dateTwo
         await this.$store.dispatch('SET_SEARCH_DATES',{date1,date2})
         let mutationOption
         let inactive=false
         let active=true
        if (visible === '3Visible') {
          await this.$store.dispatch('SET_MAIN_ITEMS_3Day')
          await this.$store.dispatch('MAIN_OVERVIEWS_3Day_DATA')
          await this.$store.dispatch('SET_TRAFFIC_DATA_3Day')
          /* await this.setData++ */
          this.threeObject.active = true;
          this.sevenObject.active = false;
          this.fourTeenObject.active = false;
          this.thirtyObject.active = false;
          this.oneEightyObject.active = false;
          await this.$store.dispatch('SET_BUTTON_ACTIVES',{a: active, b: inactive, c: inactive,d:inactive,e:inactive})
        } else if (visible === '7Visible') {
          await this.$store.dispatch('SET_MAIN_ITEMS_WEEKLY')
          await this.$store.dispatch('MAIN_OVERVIEWS_WEEKLY_DATA')
          await this.$store.dispatch('SET_TRAFFIC_DATA_WEEKLY')
          /* await this.setData++ */
          this.threeObject.active = false;
          this.sevenObject.active = true;
          this.fourTeenObject.active = false;
          this.thirtyObject.active = false;
          this.oneEightyObject.active = false;
          await this.$store.dispatch('SET_BUTTON_ACTIVES',{a: inactive, b: active, c: inactive,d:inactive,e:inactive})
        } else if (visible === '14Visible') {
          await this.$store.dispatch('SET_MAIN_ITEMS_14Day')
          await this.$store.dispatch('MAIN_OVERVIEWS_14Day_DATA')
          await this.$store.dispatch('SET_TRAFFIC_DATA_14Day')
          /* await this.setData++ */
          this.threeObject.active = false;
          this.sevenObject.active = false;
          this.fourTeenObject.active = true;
          this.thirtyObject.active = false;
          this.oneEightyObject.active = false;
          await this.$store.dispatch('SET_BUTTON_ACTIVES',{a: inactive, b: inactive, c: active,d:inactive,e:inactive})
        } else if (visible === '30Visible') {
          await this.$store.dispatch('SET_MAIN_ITEMS_MONTHLY')
          await this.$store.dispatch('MAIN_OVERVIEWS_MONTHLY_DATA')
          await this.$store.dispatch('SET_TRAFFIC_DATA_MONTHLY')
          /* await this.setData++ */
          this.threeObject.active = false;
          this.sevenObject.active = false;
          this.fourTeenObject.active = false;
          this.thirtyObject.active = true;
          this.oneEightyObject.active = false;
         await this.$store.dispatch('SET_BUTTON_ACTIVES',{a: inactive, b: inactive, c: inactive,d:active,e:inactive})
        } else if (visible === '180Visible') {
          await this.$store.dispatch('SET_MAIN_ITEMS_180Day')
          await this.$store.dispatch('MAIN_OVERVIEWS_180Day_DATA')
          await this.$store.dispatch('SET_TRAFFIC_DATA_180Day')
          /* await this.setData++ */
          this.threeObject.active = false;
          this.sevenObject.active = false;
          this.fourTeenObject.active = false;
          this.thirtyObject.active = false;
          this.oneEightyObject.active = true;
         await this.$store.dispatch('SET_BUTTON_ACTIVES',{a: inactive, b: inactive, c: inactive,d:inactive,e:active})
        }
        let site=['onedio.com']
        let service
        if(!this.$store.state.optionSelectedService.length){
          service=['adx']
        }
        else{
          service=this.$store.state.optionSelectedService
        }
        await this.$store.dispatch('SET_SITE_SERVICE',{site,service})
        await this.$events.fire('SET_DATES',this.$store.state.mainOverviewsData.filterDates)
        await this.$events.fire('SET_DATES_MAIN',this.$store.state.itemsData.filterDates)
        await this.$events.fire('SET_DATES_TRAFFIC',this.$store.state.trafficData.filterDates)
        await this.setData++
      },
  },
  async created(){
    this.request=this.$store.state.request
    if(this.request){
      this.dateOne=this.$store.state.date1
      this.dateTwo=this.$store.state.date2
      this.threeObject.active = this.$store.state.threeObject
      this.sevenObject.active = this.$store.state.sevenObject
      this.fourTeenObject.active = this.$store.state.fourTeenObject
      this.thirtyObject.active = this.$store.state.thirtyObject
      this.oneEightyObject.active = this.$store.state.oneEightyObject
      let site = await this.$store.state.selectedSites
      let service = await this.$store.state.optionSelectedService
      await this.$store.dispatch('CURRENCY')
      if(!(site.length && service.length)){
        site=['onediocom']
        service=['adx']
      }
      await this.$store.dispatch('SET_SITE_SERVICE',{site,service})
      if(this.threeObject.active===true){
        await this.$store.dispatch('SET_MAIN_ITEMS_3Day')
        await this.$store.dispatch('MAIN_OVERVIEWS_3Day_DATA')
        await this.$store.dispatch('SET_TRAFFIC_DATA_3Day')
      }
      else if(this.sevenObject.active===true){
        await this.$store.dispatch('SET_MAIN_ITEMS_WEEKLY')
        await this.$store.dispatch('MAIN_OVERVIEWS_WEEKLY_DATA')
        await this.$store.dispatch('SET_TRAFFIC_DATA_WEEKLY')
      }
      else if(this.fourTeenObject.active===true){
        await this.$store.dispatch('SET_MAIN_ITEMS_14Day')
        await this.$store.dispatch('MAIN_OVERVIEWS_14Day_DATA')
        await this.$store.dispatch('SET_TRAFFIC_DATA_14Day')
      }
      else if(this.thirtyObject.active===true){
        await this.$store.dispatch('SET_MAIN_ITEMS_MONTHLY')
        await this.$store.dispatch('MAIN_OVERVIEWS_MONTHLY_DATA')
        await this.$store.dispatch('SET_TRAFFIC_DATA_MONTHLY')
      }
      else if(this.oneEightyObject.active===true){
        await this.$store.dispatch('SET_MAIN_ITEMS_180Day')
        await this.$store.dispatch('MAIN_OVERVIEWS_180Day_DATA')
        await this.$store.dispatch('SET_TRAFFIC_DATA_180Day')
      }
      else{
        let date1=this.dateOne
        let date2=this.dateTwo
        await this.$store.dispatch('SET_MAIN_ITEMS_SEARCH', {date1,date2});
        await this.$store.dispatch('MAIN_OVERVIEWS_SEARCH_DATA', {date1,date2})
        await this.$store.dispatch('SET_TRAFFIC_DATA_SEARCH', {date1,date2});
      }
      await this.$events.fire('SET_DATES',this.$store.state.mainOverviewsData.filterDates)
      await this.$events.fire('SET_DATES_MAIN',this.$store.state.itemsData.filterDates)
      await this.$events.fire('SET_DATES_TRAFFIC',this.$store.state.trafficData.filterDates)
      /* await this.setData++ */
    }
    
},
}
</script>

<style lang="scss" scoped>
  .brand-minimized .app-header .navbar-brand {
      width: 100px;
      background-color: transparent;
  }
 /*  .sidebar .sidebar-nav {
    position: relative;
    flex: 1;
    width: 200px;
  }
  .form-help {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #fff;
    background-color: #2f353a;
    background-clip: padding-box;
    border: 1px solid #2f353a;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    text-align-last:left;
  }
  .option {
    text-align-last: left;
    color: #fff;
    background-color: #2f353a;
  }
.selected {
  background-color: #2f353a;
  }
  .btn {
    text-align: left;
}
.sidebar-minimized .btn {
    font-size:0;
} */
.row{
  background-color: #fff
}

 
</style>
